module.exports = __webpack_public_path__ + "img/emp-1.0d6b7b93.jpeg";